<template>
  <CContainer>
    <h3>Utilidad de Ventas</h3>
    <div>
      <CCard class="mt-4">
        <CCardBody>
          <CRow class="mt-2">
            <CCol sm="3">
              <label class="col-sm-12 text-muted font-weight-bold text-capitalize">Fecha Inicial:</label>
              <DatePicker 
                type="date"
                class="col-sm-12"
                v-model="initDate" 
                value-type="YYYY-MM-DD"
                format="DD/MM/YYYY" 
                placeholder="dd/mm/aaaa" />
            </CCol>
            <CCol sm="3">
              <label class="col-sm-12 text-muted font-weight-bold text-capitalize">Fecha Final</label>
              <DatePicker 
                type="date" 
                class="col-sm-12" 
                v-model="endDate" 
                value-type="YYYY-MM-DD"
                format="DD/MM/YYYY" 
                placeholder="dd/mm/aaaa" />
            </CCol>
            <CCol sm="3">
              <CSelect 
                class="col-sm-12"
                label="Tipo Reporte:" 
                addLabelClasses="text-muted font-weight-bold text-capitalize" 
                :options="reportTypes" 
                :value.sync="selectedReportType" />
            </CCol>
            <CCol sm="3">
              <CSelect 
                class="col-sm-12"
                label="Tipo Utilidad:" 
                addLabelClasses="text-muted font-weight-bold text-capitalize" 
                :options="utilityTypes" 
                :value.sync="selectedUtilityType" />
            </CCol>
          </CRow>
          <CRow>
            <!-- <CCol sm="6">
              <CSelect 
                class="col-sm-12"
                label="Grupo de Empleado:" 
                addLabelClasses="text-muted font-weight-bold text-capitalize" 
                :options="employees.map(item => { return { value: item.id_Personal, label: item.nombre_Empleado }})"
                :value.sync="selectedStaffGroup"
              />
            </CCol> -->
            <!-- <CCol sm="6">
              <CSelect 
                class="col-sm-12"
                label="Empleado:" 
                addLabelClasses="text-muted font-weight-bold text-capitalize" 
                :options="employees.map(item => { return { value: item.id_Personal, label: item.nombre_Empleado }})"
                :value.sync="selectedEmployee"
              />
            </CCol> -->
          </CRow>
          <CRow>
            <CCol sm="12">
              <div class="col-sm-12">
                <CButton 
                  color="info" 
                  @click="getData()">
                  <CIcon name="cil-search"/>
                  <span class="ml-2 align-middle">Consultar</span>
                </CButton>
                <JsonExcel 
                  class="d-inline-block"
                  name="UtilidadDocumentos.xml" 
                  worksheet="Utilidades" 
                  :data="null" 
                  :fields="null">
                  <CButton color="dark" class="ml-3" variant="outline">
                    <CIcon name="cil-cloud-download" class="mr-2"></CIcon>
                    <span>Excel</span>
                  </CButton>
                </JsonExcel>
              </div>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
      <CCard class="mt-4">
        <CCardBody class="p-5">
          <CDataTable 
            hover 
            :items="items" 
            :fields="fields">
            <template #descripcion="{item}">
              <td>
                <h4>{{ item.Descripcion }}</h4>
              </td>
            </template>
            <template #valores="{item}">
              <td>
                <div>
                  <i class="bi bi-cart3 h5 text-s3green mr-1"></i>
                  <span>${{ formatter.format(item.Valor_Mercancia, 0) }}</span>
                </div>
                <div>
                  <i class="bi bi-cash-stack h5 text-warning mr-1"></i>
                  <span>${{ formatter.format(item.Valor_Costo, 0) }}</span>
                </div>
              </td>
            </template>
            <template #utilidades="{item}">
              <td>
                <div>
                  <i class="bi bi-graph-up-arrow h4 text-info"></i>
                  <span class="font-weight-bold h4 ml-1">{{ item.Porcentaje_Utilidad }}%</span>
                </div>
                <div>
                  <span class="font-weight-bold">${{ formatter.format(item.Valor_Utilidad, 0) }}</span>
                </div>
              </td>
            </template>
            <template #presupuesto="{item}">
              <td>
                <div>
                  <span>
                    <i class="bi bi-speedometer2 mr-1 h5"></i>
                    ${{ formatter.format(item.Valor_Presupuesto, 0) }}
                  </span>
                </div>
                <div v-if="item.Valor_Presupuesto > 0">
                  <CProgress 
                    color="info" 
                    size="xs" 
                    :value="((item.Valor_Mercancia / item.Valor_Presupuesto) * 100)"/>
                  <span>{{ formatter.format(((item.Valor_Mercancia / item.Valor_Presupuesto) * 100), 2) }}%</span>
                </div>
              </td>
            </template>
          </CDataTable>

          <CElementCover v-show="loading" />
        </CCardBody>
      </CCard>
    </div>
</CContainer>
</template>
<script>
  import "vue2-datepicker/index.css";

  import moment from 'moment'
  import DatePicker from "vue2-datepicker"
  import JsonExcel from 'vue-json-excel'
  import { formatter } from '../../general'
  import { dataListPersonal } from '../../api.js'
  import { dataCostoVentasDocumentos } from "@/apiData"

  const fields = [
    {
      key: "descripcion",
      label: "Descripción",
      _style: "text-align:center"
    },
    {
      key: "valores",
      label: "Valores"
    },
    {
      key: "utilidades",
      label: "Utilidad"
    },
    {
      key: "presupuesto",
      label: "Presupuesto"
    }
  ]

  export default {
    name: 'DocumentSalesProfit',
    data() {
      return {
        formatter,
        loading: false,
        fields,
        items: [],
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        initDate: "",
        endDate: "",
        reportTypes: [
          { label: "Grupos", value: "G" },
          { label: "Vendedores", value: "V" },
          { label: "Clientes", value: "C" },
          { label: "Facturas", value: "F" }
        ],
        selectedReportType: "G",
        utilityTypes: [
          { label: 'Utilidad/Costo', value: 'costo' },
          { label: 'Utilidad/Venta', value: 'venta' }
        ],
        selectedUtilityType: "venta",
        staffGroups: [],
        selectedStaffGroup: "",
        employees: [],
        selectedEmployee: ""
      }
    },
    components: {
      DatePicker,
      JsonExcel
    },
    methods: {
      // async getStaffGroups(){
      //   try {
      //     const data = await dataListCiius(this)
      //     this.ciius = [{ id_Ciiu: '', descripcion: 'Seleccionar'}, ...data]
      //   } catch {
      //     console.log()
      //   }
      // },
      async getEmployees(){
        try {
          const data = await dataListPersonal(this)
          this.employees = [{ id_Personal: '', nombre_Empleado: "Seleccionar" }, ...data]
        } catch {
          console.log()
        }
      },
      async getData() {
        this.loading = true;

        try {
          const parameters = {
            "Fecha_Inicial": this.initDate,
            "Fecha_Final": this.endDate,
            "Tipo_Reporte": this.selectedReportType,
            "Tipo_Utilidad": this.selectedUtilityType,
            "Id_GrupoPersonal": this.selectedStaffGroup ? this.selectedStaffGroup : null,
            "Id_Personal": this.selectedEmployee ? this.selectedEmployee : null
          }
          const { response } = await dataCostoVentasDocumentos(this, parameters);
          this.items = response
        } catch(error) {
          console.log(error);
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al cargar los datos!",
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      updateTable() {
        if (this.initDate && this.endDate) {
          this.idEmployee = this.selectedEmployee.length ? this.selectedEmployee : null

          this.updateComponent += 1
        }
      },
    },
    created() {
      this.initDate = moment().startOf('month').format("YYYY-MM-DD")
      this.endDate = moment().format("YYYY-MM-DD")
    },
    async mounted() {

      switch (this.$store.state.user.data.tipo_Empleado) {
        case "A":
          this.selectedReportType = "G"
          break
        case "D":
          this.selectedReportType = "V"
          this.selectedStaffGroup = this.$store.state.user.data.id_GrupoPersonal

          this.reportTypes.splice(0, 1)
          break
        case "V":
          this.selectedReportType = "C"
          this.selectedEmployee = this.$store.state.user.data.id_Empleado

          this.reportTypes.splice(0, 2)
          break
      }

      await this.getData();
    },
  }
</script>